import {
  ScopeOfPracticeEnum,
  ShiftTypeEnum,
  ShiftStatusEnum,
} from '@umss/shared/utils';
import { UnifiedShiftItemTypeEnum } from './unified-shift.dto';

// DTO for searching/filtering unified shifts
// Extends base pagination parameters with specific filters
export interface UnifiedShiftSearchDto {
  // Pagination parameters
  pageNumber?: number; // Default: 1, Range: [1, int.MaxValue]
  pageSize?: number; // Default: 20, Range: [1, 100]
  searchTerm?: string | null;
  sortBy?: string | null;
  sortDescending?: boolean; // Default: false

  // Specific filters
  // Filter by item type: 'shift', 'shiftNeed', or null for both
  itemType?: UnifiedShiftItemTypeEnum | null;

  // Filter by scope of practice
  scopeOfPractice?: ScopeOfPracticeEnum | null;

  // Filter by shift status
  status?: ShiftStatusEnum | null;

  // Filter by shift type
  shiftType?: ShiftTypeEnum | null;

  // Start date for date range filter (ISO string: YYYY-MM-DD)
  startDate?: string | null;

  // End date for date range filter (ISO string: YYYY-MM-DD)
  endDate?: string | null;

  // Filter by contractor ID (for assigned shifts)
  contractorId?: string | null;
}
